// extracted by mini-css-extract-plugin
export default {"root":"styles_root__APPfg","card":"styles_card__O5hR5","subtitle":"styles_subtitle__VV4Y5","unit":"styles_unit__yx2U1","body":"styles_body__Q6DPU"};